import React, { useContext, useEffect, useState } from "react";
import { createStyles, makeStyles } from "@mui/styles";
import { Theme } from "@mui/material/styles";
import { Button, Modal, Paper, Snackbar, Stack, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";
import { Box } from "@mui/material";
import CloseIcon from "@mui/icons-material/Close";
import CadernoLayout from "../../../Styles/layout/cadernoLayout";
import { del, get, post } from "../../../Services/tokenConfig";
import { TabelaCalendarioRega } from "./tableRega";
import ConfirmDialog from "../../../Components/CustomDialog/customdialog";
import LoadingVulpes from "../../../Styles/Loader/loading";
import { CustomThemeProvider } from "../../../Styles/theme/customThemeprovider";
import { func_print } from "../../../Func_genericas/func_print";
import BeneficiarioNomeIdAlinhadoDireita from "../../../Componentes_modulo/Beneficiario_nome_id_alinhado_direita";
import { ICabecalho, IPage6 } from "../../../Interfaces/cadernos/caderno6";
import { Alert } from "../../../Components/Alert/Alert";
import { ButtonCadernos } from "../../../Components/barra-de-ferramentas/ButtonCadernos";
import { StyledTableCell, StyledTableCellCabecalho, StyledTableHeadLeft } from "../../../Styles/tabelCellStyled/customTableCell";
import BasicPopover from "../../../Components/Popover";
import 'dayjs/locale/pt';
import { formatarNumero_recebido_com_casa_decimais } from "../../../Func_genericas/formatar_numero_formato_pt";
import { AuthContext } from "../../../AuthContext/AuthContext";
import { CabecalhoForm } from "./cabecalho";
import Calendar from "react-calendar";
import './calendario.css';
import { getWeekNumber } from 'react-calendar/dist/esm/shared/dates';
import dayjs from "dayjs";
import { cores, mensagem_tem_a_certeza_de_apagar_alteracoes, meses_ano } from "../../../Func_genericas/valores_estaticos";
import FileCopyIcon from '@mui/icons-material/FileCopy';
import { useLocation } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    root: {
      display: "flex",
    },
    contents: {
      flexGrow: 1,
      padding: theme.spacing(0),
    },
    toolbars: {
      display: "flex",
      alignItems: "center",
      justifyContent: "flex-end",
      padding: theme.spacing(2, 3),
      // necessary for content to be below app bar
      ...theme.mixins.toolbar,
    },
  })
);


export default function RegCalRega() {
  const auth = useContext(AuthContext);
  const location = useLocation();
  const is_historico = location.state?.is_historico ?? false;

  const classes = useStyles();
  const [message, setMessage] = React.useState<string>("");
  const [isLoading, setIsLoading] = useState<boolean>(true);

  const [openSnackSuccess, setOpenSnackSuccess] = React.useState<boolean>(false);
  const [openSnackError, setOpenSnackError] = React.useState<boolean>(false);



  const [openDelete, setOpenDelete] = React.useState<boolean>(false);
  const [create, setCreate] = useState<boolean>(false);
  const [flag_edit_obj, set_flag_edit_obj] = useState<boolean>(false);
  const [flag_clonar_obj, set_flag_clonar_obj] = useState<boolean>(false);


  const [obj_anexo_cabecalho_selecionado, set_obj_anexo_cabecalho_selecionado] = useState<ICabecalho | undefined>();

  const [tabelas, setTabelas] = useState<IPage6[]>([]);
  const [tabela, setTabela] = useState<IPage6 | undefined>();


  // const [lista_datas_preenchidas, set_lista_datas_preenchidas] = useState<any>([])
  const [data_selecionada, set_data_selecionada] = useState<any>()


  const [open_modal_create_tabela, set_open_modal_create_tabela] = React.useState<boolean>(false);
  const [numero_semana_default, set_numero_semana_default] = React.useState<number | undefined>();
  const [mes_default, set_mes_default] = React.useState<string | undefined>();
  const [date_camp_1_default, set_date_camp_1_default] = React.useState<string | undefined>();
  const [date_camp_2_default, set_date_camp_2_default] = React.useState<string | undefined>();
  const [date_camp_3_default, set_date_camp_3_default] = React.useState<string | undefined>();
  const [date_camp_4_default, set_date_camp_4_default] = React.useState<string | undefined>();
  const [date_camp_5_default, set_date_camp_5_default] = React.useState<string | undefined>();
  const [date_camp_6_default, set_date_camp_6_default] = React.useState<string | undefined>();
  const [date_camp_7_default, set_date_camp_7_default] = React.useState<string | undefined>();

  const [flag_editado, set_flag_editado] = React.useState(false);
  const [open_modal_tem_a_certeza_que_quer_apagar_alteracoes, set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes] = React.useState(false);

  const handleCloseDialog = () => {
    set_open_modal_create_tabela(false)
    set_flag_edit_obj(false)
    setCreate(false)
    set_flag_clonar_obj(false)
    setTabela(undefined)
    set_flag_editado(false)
    set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)
  };


  const format_date_type_DD_MMM_ddd = (data: string) => {
    let date_aux = dayjs(data)
    return date_aux.format('DD MMM, ddd')

  }

  /************************** TABLE *************************************************************/
  async function getTabelaByCabecalho() {
    setIsLoading(true);
    try {
      if (obj_anexo_cabecalho_selecionado !== undefined) {
        let res = await get(auth.token.cookie_token, `/get_reg_horario_rega_seis_cabecalho/${obj_anexo_cabecalho_selecionado.id_horario_rega}`);
        if (res.status === 200) {

          let lista_datas_aux: any[] = []
          res.data.result.forEach((el: any) => {
            lista_datas_aux.push(el?.date_camp_1)
            lista_datas_aux.push(el?.date_camp_2)
            lista_datas_aux.push(el?.date_camp_3)
            lista_datas_aux.push(el?.date_camp_4)
            lista_datas_aux.push(el?.date_camp_5)
            lista_datas_aux.push(el?.date_camp_6)
            lista_datas_aux.push(el?.date_camp_7)
            // lista_datas_aux.push(new Date(el?.date_camp_1))
            // lista_datas_aux.push(new Date(el?.date_camp_2))
            // lista_datas_aux.push(new Date(el?.date_camp_3))
            // lista_datas_aux.push(new Date(el?.date_camp_4))
            // lista_datas_aux.push(new Date(el?.date_camp_5))
            // lista_datas_aux.push(new Date(el?.date_camp_6))
            // lista_datas_aux.push(new Date(el?.date_camp_7))
          })

          // set_lista_datas_preenchidas(lista_datas_aux)
          setTabelas(res.data.result);
        }
      };
      setIsLoading(false);
    } catch (error) {
      func_print("getTabelaByCabecalho", error, true);
      setIsLoading(false);
    }
  }


  useEffect(() => {
    (async () => {
      if (obj_anexo_cabecalho_selecionado !== undefined) {

        await getTabelaByCabecalho();

      } else {
        setIsLoading(false)
      }
    })();
  }, [obj_anexo_cabecalho_selecionado]);






  // Criar
  const handleSaveTabela = async () => {

    try {
      let res = await post(auth.token.cookie_token, "new_reg_horario_rega_seis", {
        payload: {
          id_registo_rega: 0,
          capacidade_utili: tabela?.capacidade_utili === undefined ? null : tabela.capacidade_utili,
          reserva_facilmente_utiliz: tabela?.reserva_facilmente_utiliz === undefined ? null : tabela.reserva_facilmente_utiliz,
          eficiencia_rega: tabela?.eficiencia_rega === undefined ? "" : tabela.eficiencia_rega,
          mes: tabela?.mes === undefined ? mes_default : tabela.mes,
          semana_n: tabela?.semana_n === undefined ? numero_semana_default?.toString() : tabela.semana_n.toString(),
          date_camp_1: tabela?.date_camp_1 === undefined ? date_camp_1_default : tabela.date_camp_1,
          date_camp_2: tabela?.date_camp_2 === undefined ? date_camp_2_default : tabela.date_camp_2,
          date_camp_3: tabela?.date_camp_3 === undefined ? date_camp_3_default : tabela.date_camp_3,
          date_camp_4: tabela?.date_camp_4 === undefined ? date_camp_4_default : tabela.date_camp_4,
          date_camp_5: tabela?.date_camp_5 === undefined ? date_camp_5_default : tabela.date_camp_5,
          date_camp_6: tabela?.date_camp_6 === undefined ? date_camp_6_default : tabela.date_camp_6,
          date_camp_7: tabela?.date_camp_7 === undefined ? date_camp_7_default : tabela.date_camp_7,
          prefundidad_radi_camp_1: tabela?.prefundidad_radi_camp_1 === undefined ? null : tabela.prefundidad_radi_camp_1,
          prefundidad_radi_camp_2: tabela?.prefundidad_radi_camp_2 === undefined ? null : tabela.prefundidad_radi_camp_2,
          prefundidad_radi_camp_3: tabela?.prefundidad_radi_camp_3 === undefined ? null : tabela.prefundidad_radi_camp_3,
          prefundidad_radi_camp_4: tabela?.prefundidad_radi_camp_4 === undefined ? null : tabela.prefundidad_radi_camp_4,
          prefundidad_radi_camp_5: tabela?.prefundidad_radi_camp_5 === undefined ? null : tabela.prefundidad_radi_camp_5,
          prefundidad_radi_camp_6: tabela?.prefundidad_radi_camp_6 === undefined ? null : tabela.prefundidad_radi_camp_6,
          prefundidad_radi_camp_7: tabela?.prefundidad_radi_camp_7 === undefined ? null : tabela.prefundidad_radi_camp_7,
          capacidade_campo_camp_1: tabela?.capacidade_campo_camp_1 === undefined ? null : tabela.capacidade_campo_camp_1,
          capacidade_campo_camp_2: tabela?.capacidade_campo_camp_2 === undefined ? null : tabela.capacidade_campo_camp_2,
          capacidade_campo_camp_3: tabela?.capacidade_campo_camp_3 === undefined ? null : tabela.capacidade_campo_camp_3,
          capacidade_campo_camp_4: tabela?.capacidade_campo_camp_4 === undefined ? null : tabela.capacidade_campo_camp_4,
          capacidade_campo_camp_5: tabela?.capacidade_campo_camp_5 === undefined ? null : tabela.capacidade_campo_camp_5,
          capacidade_campo_camp_6: tabela?.capacidade_campo_camp_6 === undefined ? null : tabela.capacidade_campo_camp_6,
          capacidade_campo_camp_7: tabela?.capacidade_campo_camp_7 === undefined ? null : tabela.capacidade_campo_camp_7,
          teor_crit_cul_camp_1: tabela?.teor_crit_cul_camp_1 === undefined ? null : tabela.teor_crit_cul_camp_1,
          teor_crit_cul_camp_2: tabela?.teor_crit_cul_camp_2 === undefined ? null : tabela.teor_crit_cul_camp_2,
          teor_crit_cul_camp_3: tabela?.teor_crit_cul_camp_3 === undefined ? null : tabela.teor_crit_cul_camp_3,
          teor_crit_cul_camp_4: tabela?.teor_crit_cul_camp_4 === undefined ? null : tabela.teor_crit_cul_camp_4,
          teor_crit_cul_camp_5: tabela?.teor_crit_cul_camp_5 === undefined ? null : tabela.teor_crit_cul_camp_5,
          teor_crit_cul_camp_6: tabela?.teor_crit_cul_camp_6 === undefined ? null : tabela.teor_crit_cul_camp_6,
          teor_crit_cul_camp_7: tabela?.teor_crit_cul_camp_7 === undefined ? null : tabela.teor_crit_cul_camp_7,
          teor_agua_inicio_camp_1: tabela?.teor_agua_inicio_camp_1 === undefined ? null : tabela.teor_agua_inicio_camp_1,
          teor_agua_inicio_camp_2: tabela?.teor_agua_inicio_camp_2 === undefined ? null : tabela.teor_agua_inicio_camp_2,
          teor_agua_inicio_camp_3: tabela?.teor_agua_inicio_camp_3 === undefined ? null : tabela.teor_agua_inicio_camp_3,
          teor_agua_inicio_camp_4: tabela?.teor_agua_inicio_camp_4 === undefined ? null : tabela.teor_agua_inicio_camp_4,
          teor_agua_inicio_camp_5: tabela?.teor_agua_inicio_camp_5 === undefined ? null : tabela.teor_agua_inicio_camp_5,
          teor_agua_inicio_camp_6: tabela?.teor_agua_inicio_camp_6 === undefined ? null : tabela.teor_agua_inicio_camp_6,
          teor_agua_inicio_camp_7: tabela?.teor_agua_inicio_camp_7 === undefined ? null : tabela.teor_agua_inicio_camp_7,
          eto_camp_1: tabela?.eto_camp_1 === undefined ? null : tabela.eto_camp_1,
          eto_camp_2: tabela?.eto_camp_2 === undefined ? null : tabela.eto_camp_2,
          eto_camp_3: tabela?.eto_camp_3 === undefined ? null : tabela.eto_camp_3,
          eto_camp_4: tabela?.eto_camp_4 === undefined ? null : tabela.eto_camp_4,
          eto_camp_5: tabela?.eto_camp_5 === undefined ? null : tabela.eto_camp_5,
          eto_camp_6: tabela?.eto_camp_6 === undefined ? null : tabela.eto_camp_6,
          eto_camp_7: tabela?.eto_camp_7 === undefined ? null : tabela.eto_camp_7,
          kc_camp_1: tabela?.kc_camp_1 === undefined ? null : tabela.kc_camp_1,
          kc_camp_2: tabela?.kc_camp_2 === undefined ? null : tabela.kc_camp_2,
          kc_camp_3: tabela?.kc_camp_3 === undefined ? null : tabela.kc_camp_3,
          kc_camp_4: tabela?.kc_camp_4 === undefined ? null : tabela.kc_camp_4,
          kc_camp_5: tabela?.kc_camp_5 === undefined ? null : tabela.kc_camp_5,
          kc_camp_6: tabela?.kc_camp_6 === undefined ? null : tabela.kc_camp_6,
          kc_camp_7: tabela?.kc_camp_7 === undefined ? null : tabela.kc_camp_7,
          etc_camp_1: tabela?.etc_camp_1 === undefined ? null : tabela.etc_camp_1,
          etc_camp_2: tabela?.etc_camp_2 === undefined ? null : tabela.etc_camp_2,
          etc_camp_3: tabela?.etc_camp_3 === undefined ? null : tabela.etc_camp_3,
          etc_camp_4: tabela?.etc_camp_4 === undefined ? null : tabela.etc_camp_4,
          etc_camp_5: tabela?.etc_camp_5 === undefined ? null : tabela.etc_camp_5,
          etc_camp_6: tabela?.etc_camp_6 === undefined ? null : tabela.etc_camp_6,
          etc_camp_7: tabela?.etc_camp_7 === undefined ? null : tabela.etc_camp_7,
          precipita_t_camp_1: tabela?.precipita_t_camp_1 === undefined ? null : tabela.precipita_t_camp_1,
          precipita_t_camp_2: tabela?.precipita_t_camp_2 === undefined ? null : tabela.precipita_t_camp_2,
          precipita_t_camp_3: tabela?.precipita_t_camp_3 === undefined ? null : tabela.precipita_t_camp_3,
          precipita_t_camp_4: tabela?.precipita_t_camp_4 === undefined ? null : tabela.precipita_t_camp_4,
          precipita_t_camp_5: tabela?.precipita_t_camp_5 === undefined ? null : tabela.precipita_t_camp_5,
          precipita_t_camp_6: tabela?.precipita_t_camp_6 === undefined ? null : tabela.precipita_t_camp_6,
          precipita_t_camp_7: tabela?.precipita_t_camp_7 === undefined ? null : tabela.precipita_t_camp_7,
          variacao_agu_camp_1: tabela?.variacao_agu_camp_1 === undefined ? null : tabela.variacao_agu_camp_1,
          variacao_agu_camp_2: tabela?.variacao_agu_camp_2 === undefined ? null : tabela.variacao_agu_camp_2,
          variacao_agu_camp_3: tabela?.variacao_agu_camp_3 === undefined ? null : tabela.variacao_agu_camp_3,
          variacao_agu_camp_4: tabela?.variacao_agu_camp_4 === undefined ? null : tabela.variacao_agu_camp_4,
          variacao_agu_camp_5: tabela?.variacao_agu_camp_5 === undefined ? null : tabela.variacao_agu_camp_5,
          variacao_agu_camp_6: tabela?.variacao_agu_camp_6 === undefined ? null : tabela.variacao_agu_camp_6,
          variacao_agu_camp_7: tabela?.variacao_agu_camp_7 === undefined ? null : tabela.variacao_agu_camp_7,
          teor_agua_solo_s_rega_camp_1: tabela?.teor_agua_solo_s_rega_camp_1 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_1,
          teor_agua_solo_s_rega_camp_2: tabela?.teor_agua_solo_s_rega_camp_2 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_2,
          teor_agua_solo_s_rega_camp_3: tabela?.teor_agua_solo_s_rega_camp_3 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_3,
          teor_agua_solo_s_rega_camp_4: tabela?.teor_agua_solo_s_rega_camp_4 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_4,
          teor_agua_solo_s_rega_camp_5: tabela?.teor_agua_solo_s_rega_camp_5 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_5,
          teor_agua_solo_s_rega_camp_6: tabela?.teor_agua_solo_s_rega_camp_6 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_6,
          teor_agua_solo_s_rega_camp_7: tabela?.teor_agua_solo_s_rega_camp_7 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_7,
          leitura_sonda_1_camp_1: tabela?.leitura_sonda_1_camp_1 === undefined ? null : tabela.leitura_sonda_1_camp_1,
          leitura_sonda_1_camp_2: tabela?.leitura_sonda_1_camp_2 === undefined ? null : tabela.leitura_sonda_1_camp_2,
          leitura_sonda_1_camp_3: tabela?.leitura_sonda_1_camp_3 === undefined ? null : tabela.leitura_sonda_1_camp_3,
          leitura_sonda_1_camp_4: tabela?.leitura_sonda_1_camp_4 === undefined ? null : tabela.leitura_sonda_1_camp_4,
          leitura_sonda_1_camp_5: tabela?.leitura_sonda_1_camp_5 === undefined ? null : tabela.leitura_sonda_1_camp_5,
          leitura_sonda_1_camp_6: tabela?.leitura_sonda_1_camp_6 === undefined ? null : tabela.leitura_sonda_1_camp_6,
          leitura_sonda_1_camp_7: tabela?.leitura_sonda_1_camp_7 === undefined ? null : tabela.leitura_sonda_1_camp_7,
          leitura_sonda_2_camp_1: tabela?.leitura_sonda_2_camp_1 === undefined ? null : tabela.leitura_sonda_2_camp_1,
          leitura_sonda_2_camp_2: tabela?.leitura_sonda_2_camp_2 === undefined ? null : tabela.leitura_sonda_2_camp_2,
          leitura_sonda_2_camp_3: tabela?.leitura_sonda_2_camp_3 === undefined ? null : tabela.leitura_sonda_2_camp_3,
          leitura_sonda_2_camp_4: tabela?.leitura_sonda_2_camp_4 === undefined ? null : tabela.leitura_sonda_2_camp_4,
          leitura_sonda_2_camp_5: tabela?.leitura_sonda_2_camp_5 === undefined ? null : tabela.leitura_sonda_2_camp_5,
          leitura_sonda_2_camp_6: tabela?.leitura_sonda_2_camp_6 === undefined ? null : tabela.leitura_sonda_2_camp_6,
          leitura_sonda_2_camp_7: tabela?.leitura_sonda_2_camp_7 === undefined ? null : tabela.leitura_sonda_2_camp_7,
          folga_prox_rega_camp_1: tabela?.folga_prox_rega_camp_1 === undefined ? null : tabela.folga_prox_rega_camp_1,
          folga_prox_rega_camp_2: tabela?.folga_prox_rega_camp_2 === undefined ? null : tabela.folga_prox_rega_camp_2,
          folga_prox_rega_camp_3: tabela?.folga_prox_rega_camp_3 === undefined ? null : tabela.folga_prox_rega_camp_3,
          folga_prox_rega_camp_4: tabela?.folga_prox_rega_camp_4 === undefined ? null : tabela.folga_prox_rega_camp_4,
          folga_prox_rega_camp_5: tabela?.folga_prox_rega_camp_5 === undefined ? null : tabela.folga_prox_rega_camp_5,
          folga_prox_rega_camp_6: tabela?.folga_prox_rega_camp_6 === undefined ? null : tabela.folga_prox_rega_camp_6,
          folga_prox_rega_camp_7: tabela?.folga_prox_rega_camp_7 === undefined ? null : tabela.folga_prox_rega_camp_7,
          rega_leitura_camp_1: tabela?.rega_leitura_camp_1 === undefined ? null : tabela.rega_leitura_camp_1,
          rega_leitura_camp_2: tabela?.rega_leitura_camp_2 === undefined ? null : tabela.rega_leitura_camp_2,
          rega_leitura_camp_3: tabela?.rega_leitura_camp_3 === undefined ? null : tabela.rega_leitura_camp_3,
          rega_leitura_camp_4: tabela?.rega_leitura_camp_4 === undefined ? null : tabela.rega_leitura_camp_4,
          rega_leitura_camp_5: tabela?.rega_leitura_camp_5 === undefined ? null : tabela.rega_leitura_camp_5,
          rega_leitura_camp_6: tabela?.rega_leitura_camp_6 === undefined ? null : tabela.rega_leitura_camp_6,
          rega_leitura_camp_7: tabela?.rega_leitura_camp_7 === undefined ? null : tabela.rega_leitura_camp_7,
          rega_dose_total_camp_1: tabela?.rega_dose_total_camp_1 === undefined ? null : tabela.rega_dose_total_camp_1,
          rega_dose_total_camp_2: tabela?.rega_dose_total_camp_2 === undefined ? null : tabela.rega_dose_total_camp_2,
          rega_dose_total_camp_3: tabela?.rega_dose_total_camp_3 === undefined ? null : tabela.rega_dose_total_camp_3,
          rega_dose_total_camp_4: tabela?.rega_dose_total_camp_4 === undefined ? null : tabela.rega_dose_total_camp_4,
          rega_dose_total_camp_5: tabela?.rega_dose_total_camp_5 === undefined ? null : tabela.rega_dose_total_camp_5,
          rega_dose_total_camp_6: tabela?.rega_dose_total_camp_6 === undefined ? null : tabela.rega_dose_total_camp_6,
          rega_dose_total_camp_7: tabela?.rega_dose_total_camp_7 === undefined ? null : tabela.rega_dose_total_camp_7,
          rega_dose_util_camp_1: tabela?.rega_dose_util_camp_1 === undefined ? null : tabela.rega_dose_util_camp_1,
          rega_dose_util_camp_2: tabela?.rega_dose_util_camp_2 === undefined ? null : tabela.rega_dose_util_camp_2,
          rega_dose_util_camp_3: tabela?.rega_dose_util_camp_3 === undefined ? null : tabela.rega_dose_util_camp_3,
          rega_dose_util_camp_4: tabela?.rega_dose_util_camp_4 === undefined ? null : tabela.rega_dose_util_camp_4,
          rega_dose_util_camp_5: tabela?.rega_dose_util_camp_5 === undefined ? null : tabela.rega_dose_util_camp_5,
          rega_dose_util_camp_6: tabela?.rega_dose_util_camp_6 === undefined ? null : tabela.rega_dose_util_camp_6,
          rega_dose_util_camp_7: tabela?.rega_dose_util_camp_7 === undefined ? null : tabela.rega_dose_util_camp_7,
          teor_agua_solo_1_camp_1: tabela?.teor_agua_solo_1_camp_1 === undefined ? null : tabela.teor_agua_solo_1_camp_1,
          teor_agua_solo_1_camp_2: tabela?.teor_agua_solo_1_camp_2 === undefined ? null : tabela.teor_agua_solo_1_camp_2,
          teor_agua_solo_1_camp_3: tabela?.teor_agua_solo_1_camp_3 === undefined ? null : tabela.teor_agua_solo_1_camp_3,
          teor_agua_solo_1_camp_4: tabela?.teor_agua_solo_1_camp_4 === undefined ? null : tabela.teor_agua_solo_1_camp_4,
          teor_agua_solo_1_camp_5: tabela?.teor_agua_solo_1_camp_5 === undefined ? null : tabela.teor_agua_solo_1_camp_5,
          teor_agua_solo_1_camp_6: tabela?.teor_agua_solo_1_camp_6 === undefined ? null : tabela.teor_agua_solo_1_camp_6,
          teor_agua_solo_1_camp_7: tabela?.teor_agua_solo_1_camp_7 === undefined ? null : tabela.teor_agua_solo_1_camp_7,
          perda_agua_camp_1: tabela?.perda_agua_camp_1 === undefined ? null : tabela.perda_agua_camp_1,
          perda_agua_camp_2: tabela?.perda_agua_camp_2 === undefined ? null : tabela.perda_agua_camp_2,
          perda_agua_camp_3: tabela?.perda_agua_camp_3 === undefined ? null : tabela.perda_agua_camp_3,
          perda_agua_camp_4: tabela?.perda_agua_camp_4 === undefined ? null : tabela.perda_agua_camp_4,
          perda_agua_camp_5: tabela?.perda_agua_camp_5 === undefined ? null : tabela.perda_agua_camp_5,
          perda_agua_camp_6: tabela?.perda_agua_camp_6 === undefined ? null : tabela.perda_agua_camp_6,
          perda_agua_camp_7: tabela?.perda_agua_camp_7 === undefined ? null : tabela.perda_agua_camp_7,
          ident_camp1: tabela?.ident_camp1 === undefined ? null : tabela.ident_camp1,
          ident_camp2: tabela?.ident_camp2 === undefined ? null : tabela.ident_camp2,
          ident_camp3: tabela?.ident_camp3 === undefined ? null : tabela.ident_camp3,
          ident_camp4: tabela?.ident_camp4 === undefined ? null : tabela.ident_camp4,
          id_horario_rega: obj_anexo_cabecalho_selecionado?.id_horario_rega,
          last_update: new Date().toISOString(),
          create_date: new Date().toISOString(),
          uuid: "",
        }
      });
      if (res.status === 200) {
        setMessage("Gravado com sucesso!");

        setTabela(res.data.result)
        set_flag_editado(false)
        setTabelas((prev: any) => [...prev, res.data.result])
        setCreate(false);
        setOpenSnackSuccess(true);

      } else {
        setMessage("Erro ao gravar!");
        setOpenSnackError(true);
      }
      setIsLoading(false);
    } catch (error: any) {
      func_print("handleSave", error, true);
      if ((error as any)?.response?.data?.message) {
        setMessage((error as any).response.data.message);
      } else {
        setMessage("Erro ao efetuar a sua operação!");
      }
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };

  // EDIT
  const handleUpdatetabela = async () => {
    if (tabela !== undefined) {

      try {
        setIsLoading(true);

        let res = await post(auth.token.cookie_token, `update_reg_horario_rega_seis`, {
          payload: {
            id_registo_rega: tabela.id_registo_rega,
            capacidade_utili: tabela?.capacidade_utili === undefined ? null : tabela.capacidade_utili,
            reserva_facilmente_utiliz: tabela?.reserva_facilmente_utiliz === undefined ? null : tabela.reserva_facilmente_utiliz,
            eficiencia_rega: tabela?.eficiencia_rega === undefined ? "" : tabela.eficiencia_rega,
            mes: tabela?.mes === undefined ? "" : tabela.mes,
            semana_n: tabela?.semana_n === undefined ? '' : (tabela.semana_n).toString(),
            date_camp_1: tabela?.date_camp_1 === undefined ? null : (tabela.date_camp_1),
            date_camp_2: tabela?.date_camp_2 === undefined ? null : (tabela.date_camp_2),
            date_camp_3: tabela?.date_camp_3 === undefined ? null : (tabela.date_camp_3),
            date_camp_4: tabela?.date_camp_4 === undefined ? null : (tabela.date_camp_4),
            date_camp_5: tabela?.date_camp_5 === undefined ? null : (tabela.date_camp_5),
            date_camp_6: tabela?.date_camp_6 === undefined ? null : (tabela.date_camp_6),
            date_camp_7: tabela?.date_camp_7 === undefined ? null : (tabela.date_camp_7),
            prefundidad_radi_camp_1: tabela?.prefundidad_radi_camp_1 === undefined ? null : tabela.prefundidad_radi_camp_1,
            prefundidad_radi_camp_2: tabela?.prefundidad_radi_camp_2 === undefined ? null : tabela.prefundidad_radi_camp_2,
            prefundidad_radi_camp_3: tabela?.prefundidad_radi_camp_3 === undefined ? null : tabela.prefundidad_radi_camp_3,
            prefundidad_radi_camp_4: tabela?.prefundidad_radi_camp_4 === undefined ? null : tabela.prefundidad_radi_camp_4,
            prefundidad_radi_camp_5: tabela?.prefundidad_radi_camp_5 === undefined ? null : tabela.prefundidad_radi_camp_5,
            prefundidad_radi_camp_6: tabela?.prefundidad_radi_camp_6 === undefined ? null : tabela.prefundidad_radi_camp_6,
            prefundidad_radi_camp_7: tabela?.prefundidad_radi_camp_7 === undefined ? null : tabela.prefundidad_radi_camp_7,
            capacidade_campo_camp_1: tabela?.capacidade_campo_camp_1 === undefined ? null : tabela.capacidade_campo_camp_1,
            capacidade_campo_camp_2: tabela?.capacidade_campo_camp_2 === undefined ? null : tabela.capacidade_campo_camp_2,
            capacidade_campo_camp_3: tabela?.capacidade_campo_camp_3 === undefined ? null : tabela.capacidade_campo_camp_3,
            capacidade_campo_camp_4: tabela?.capacidade_campo_camp_4 === undefined ? null : tabela.capacidade_campo_camp_4,
            capacidade_campo_camp_5: tabela?.capacidade_campo_camp_5 === undefined ? null : tabela.capacidade_campo_camp_5,
            capacidade_campo_camp_6: tabela?.capacidade_campo_camp_6 === undefined ? null : tabela.capacidade_campo_camp_6,
            capacidade_campo_camp_7: tabela?.capacidade_campo_camp_7 === undefined ? null : tabela.capacidade_campo_camp_7,
            teor_crit_cul_camp_1: tabela?.teor_crit_cul_camp_1 === undefined ? null : tabela.teor_crit_cul_camp_1,
            teor_crit_cul_camp_2: tabela?.teor_crit_cul_camp_2 === undefined ? null : tabela.teor_crit_cul_camp_2,
            teor_crit_cul_camp_3: tabela?.teor_crit_cul_camp_3 === undefined ? null : tabela.teor_crit_cul_camp_3,
            teor_crit_cul_camp_4: tabela?.teor_crit_cul_camp_4 === undefined ? null : tabela.teor_crit_cul_camp_4,
            teor_crit_cul_camp_5: tabela?.teor_crit_cul_camp_5 === undefined ? null : tabela.teor_crit_cul_camp_5,
            teor_crit_cul_camp_6: tabela?.teor_crit_cul_camp_6 === undefined ? null : tabela.teor_crit_cul_camp_6,
            teor_crit_cul_camp_7: tabela?.teor_crit_cul_camp_7 === undefined ? null : tabela.teor_crit_cul_camp_7,
            teor_agua_inicio_camp_1: tabela?.teor_agua_inicio_camp_1 === undefined ? null : tabela.teor_agua_inicio_camp_1,
            teor_agua_inicio_camp_2: tabela?.teor_agua_inicio_camp_2 === undefined ? null : tabela.teor_agua_inicio_camp_2,
            teor_agua_inicio_camp_3: tabela?.teor_agua_inicio_camp_3 === undefined ? null : tabela.teor_agua_inicio_camp_3,
            teor_agua_inicio_camp_4: tabela?.teor_agua_inicio_camp_4 === undefined ? null : tabela.teor_agua_inicio_camp_4,
            teor_agua_inicio_camp_5: tabela?.teor_agua_inicio_camp_5 === undefined ? null : tabela.teor_agua_inicio_camp_5,
            teor_agua_inicio_camp_6: tabela?.teor_agua_inicio_camp_6 === undefined ? null : tabela.teor_agua_inicio_camp_6,
            teor_agua_inicio_camp_7: tabela?.teor_agua_inicio_camp_7 === undefined ? null : tabela.teor_agua_inicio_camp_7,
            eto_camp_1: tabela?.eto_camp_1 === undefined ? null : tabela.eto_camp_1,
            eto_camp_2: tabela?.eto_camp_2 === undefined ? null : tabela.eto_camp_2,
            eto_camp_3: tabela?.eto_camp_3 === undefined ? null : tabela.eto_camp_3,
            eto_camp_4: tabela?.eto_camp_4 === undefined ? null : tabela.eto_camp_4,
            eto_camp_5: tabela?.eto_camp_5 === undefined ? null : tabela.eto_camp_5,
            eto_camp_6: tabela?.eto_camp_6 === undefined ? null : tabela.eto_camp_6,
            eto_camp_7: tabela?.eto_camp_7 === undefined ? null : tabela.eto_camp_7,
            kc_camp_1: tabela?.kc_camp_1 === undefined ? null : tabela.kc_camp_1,
            kc_camp_2: tabela?.kc_camp_2 === undefined ? null : tabela.kc_camp_2,
            kc_camp_3: tabela?.kc_camp_3 === undefined ? null : tabela.kc_camp_3,
            kc_camp_4: tabela?.kc_camp_4 === undefined ? null : tabela.kc_camp_4,
            kc_camp_5: tabela?.kc_camp_5 === undefined ? null : tabela.kc_camp_5,
            kc_camp_6: tabela?.kc_camp_6 === undefined ? null : tabela.kc_camp_6,
            kc_camp_7: tabela?.kc_camp_7 === undefined ? null : tabela.kc_camp_7,
            etc_camp_1: tabela?.etc_camp_1 === undefined ? null : tabela.etc_camp_1,
            etc_camp_2: tabela?.etc_camp_2 === undefined ? null : tabela.etc_camp_2,
            etc_camp_3: tabela?.etc_camp_3 === undefined ? null : tabela.etc_camp_3,
            etc_camp_4: tabela?.etc_camp_4 === undefined ? null : tabela.etc_camp_4,
            etc_camp_5: tabela?.etc_camp_5 === undefined ? null : tabela.etc_camp_5,
            etc_camp_6: tabela?.etc_camp_6 === undefined ? null : tabela.etc_camp_6,
            etc_camp_7: tabela?.etc_camp_7 === undefined ? null : tabela.etc_camp_7,
            precipita_t_camp_1: tabela?.precipita_t_camp_1 === undefined ? null : tabela.precipita_t_camp_1,
            precipita_t_camp_2: tabela?.precipita_t_camp_2 === undefined ? null : tabela.precipita_t_camp_2,
            precipita_t_camp_3: tabela?.precipita_t_camp_3 === undefined ? null : tabela.precipita_t_camp_3,
            precipita_t_camp_4: tabela?.precipita_t_camp_4 === undefined ? null : tabela.precipita_t_camp_4,
            precipita_t_camp_5: tabela?.precipita_t_camp_5 === undefined ? null : tabela.precipita_t_camp_5,
            precipita_t_camp_6: tabela?.precipita_t_camp_6 === undefined ? null : tabela.precipita_t_camp_6,
            precipita_t_camp_7: tabela?.precipita_t_camp_7 === undefined ? null : tabela.precipita_t_camp_7,
            variacao_agu_camp_1: tabela?.variacao_agu_camp_1 === undefined ? null : tabela.variacao_agu_camp_1,
            variacao_agu_camp_2: tabela?.variacao_agu_camp_2 === undefined ? null : tabela.variacao_agu_camp_2,
            variacao_agu_camp_3: tabela?.variacao_agu_camp_3 === undefined ? null : tabela.variacao_agu_camp_3,
            variacao_agu_camp_4: tabela?.variacao_agu_camp_4 === undefined ? null : tabela.variacao_agu_camp_4,
            variacao_agu_camp_5: tabela?.variacao_agu_camp_5 === undefined ? null : tabela.variacao_agu_camp_5,
            variacao_agu_camp_6: tabela?.variacao_agu_camp_6 === undefined ? null : tabela.variacao_agu_camp_6,
            variacao_agu_camp_7: tabela?.variacao_agu_camp_7 === undefined ? null : tabela.variacao_agu_camp_7,
            teor_agua_solo_s_rega_camp_1: tabela?.teor_agua_solo_s_rega_camp_1 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_1,
            teor_agua_solo_s_rega_camp_2: tabela?.teor_agua_solo_s_rega_camp_2 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_2,
            teor_agua_solo_s_rega_camp_3: tabela?.teor_agua_solo_s_rega_camp_3 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_3,
            teor_agua_solo_s_rega_camp_4: tabela?.teor_agua_solo_s_rega_camp_4 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_4,
            teor_agua_solo_s_rega_camp_5: tabela?.teor_agua_solo_s_rega_camp_5 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_5,
            teor_agua_solo_s_rega_camp_6: tabela?.teor_agua_solo_s_rega_camp_6 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_6,
            teor_agua_solo_s_rega_camp_7: tabela?.teor_agua_solo_s_rega_camp_7 === undefined ? null : tabela.teor_agua_solo_s_rega_camp_7,
            leitura_sonda_1_camp_1: tabela?.leitura_sonda_1_camp_1 === undefined ? null : tabela.leitura_sonda_1_camp_1,
            leitura_sonda_1_camp_2: tabela?.leitura_sonda_1_camp_2 === undefined ? null : tabela.leitura_sonda_1_camp_2,
            leitura_sonda_1_camp_3: tabela?.leitura_sonda_1_camp_3 === undefined ? null : tabela.leitura_sonda_1_camp_3,
            leitura_sonda_1_camp_4: tabela?.leitura_sonda_1_camp_4 === undefined ? null : tabela.leitura_sonda_1_camp_4,
            leitura_sonda_1_camp_5: tabela?.leitura_sonda_1_camp_5 === undefined ? null : tabela.leitura_sonda_1_camp_5,
            leitura_sonda_1_camp_6: tabela?.leitura_sonda_1_camp_6 === undefined ? null : tabela.leitura_sonda_1_camp_6,
            leitura_sonda_1_camp_7: tabela?.leitura_sonda_1_camp_7 === undefined ? null : tabela.leitura_sonda_1_camp_7,
            leitura_sonda_2_camp_1: tabela?.leitura_sonda_2_camp_1 === undefined ? null : tabela.leitura_sonda_2_camp_1,
            leitura_sonda_2_camp_2: tabela?.leitura_sonda_2_camp_2 === undefined ? null : tabela.leitura_sonda_2_camp_2,
            leitura_sonda_2_camp_3: tabela?.leitura_sonda_2_camp_3 === undefined ? null : tabela.leitura_sonda_2_camp_3,
            leitura_sonda_2_camp_4: tabela?.leitura_sonda_2_camp_4 === undefined ? null : tabela.leitura_sonda_2_camp_4,
            leitura_sonda_2_camp_5: tabela?.leitura_sonda_2_camp_5 === undefined ? null : tabela.leitura_sonda_2_camp_5,
            leitura_sonda_2_camp_6: tabela?.leitura_sonda_2_camp_6 === undefined ? null : tabela.leitura_sonda_2_camp_6,
            leitura_sonda_2_camp_7: tabela?.leitura_sonda_2_camp_7 === undefined ? null : tabela.leitura_sonda_2_camp_7,
            folga_prox_rega_camp_1: tabela?.folga_prox_rega_camp_1 === undefined ? null : tabela.folga_prox_rega_camp_1,
            folga_prox_rega_camp_2: tabela?.folga_prox_rega_camp_2 === undefined ? null : tabela.folga_prox_rega_camp_2,
            folga_prox_rega_camp_3: tabela?.folga_prox_rega_camp_3 === undefined ? null : tabela.folga_prox_rega_camp_3,
            folga_prox_rega_camp_4: tabela?.folga_prox_rega_camp_4 === undefined ? null : tabela.folga_prox_rega_camp_4,
            folga_prox_rega_camp_5: tabela?.folga_prox_rega_camp_5 === undefined ? null : tabela.folga_prox_rega_camp_5,
            folga_prox_rega_camp_6: tabela?.folga_prox_rega_camp_6 === undefined ? null : tabela.folga_prox_rega_camp_6,
            folga_prox_rega_camp_7: tabela?.folga_prox_rega_camp_7 === undefined ? null : tabela.folga_prox_rega_camp_7,
            rega_leitura_camp_1: tabela?.rega_leitura_camp_1 === undefined ? null : tabela.rega_leitura_camp_1,
            rega_leitura_camp_2: tabela?.rega_leitura_camp_2 === undefined ? null : tabela.rega_leitura_camp_2,
            rega_leitura_camp_3: tabela?.rega_leitura_camp_3 === undefined ? null : tabela.rega_leitura_camp_3,
            rega_leitura_camp_4: tabela?.rega_leitura_camp_4 === undefined ? null : tabela.rega_leitura_camp_4,
            rega_leitura_camp_5: tabela?.rega_leitura_camp_5 === undefined ? null : tabela.rega_leitura_camp_5,
            rega_leitura_camp_6: tabela?.rega_leitura_camp_6 === undefined ? null : tabela.rega_leitura_camp_6,
            rega_leitura_camp_7: tabela?.rega_leitura_camp_7 === undefined ? null : tabela.rega_leitura_camp_7,
            rega_dose_total_camp_1: tabela?.rega_dose_total_camp_1 === undefined ? null : tabela.rega_dose_total_camp_1,
            rega_dose_total_camp_2: tabela?.rega_dose_total_camp_2 === undefined ? null : tabela.rega_dose_total_camp_2,
            rega_dose_total_camp_3: tabela?.rega_dose_total_camp_3 === undefined ? null : tabela.rega_dose_total_camp_3,
            rega_dose_total_camp_4: tabela?.rega_dose_total_camp_4 === undefined ? null : tabela.rega_dose_total_camp_4,
            rega_dose_total_camp_5: tabela?.rega_dose_total_camp_5 === undefined ? null : tabela.rega_dose_total_camp_5,
            rega_dose_total_camp_6: tabela?.rega_dose_total_camp_6 === undefined ? null : tabela.rega_dose_total_camp_6,
            rega_dose_total_camp_7: tabela?.rega_dose_total_camp_7 === undefined ? null : tabela.rega_dose_total_camp_7,
            rega_dose_util_camp_1: tabela?.rega_dose_util_camp_1 === undefined ? null : tabela.rega_dose_util_camp_1,
            rega_dose_util_camp_2: tabela?.rega_dose_util_camp_2 === undefined ? null : tabela.rega_dose_util_camp_2,
            rega_dose_util_camp_3: tabela?.rega_dose_util_camp_3 === undefined ? null : tabela.rega_dose_util_camp_3,
            rega_dose_util_camp_4: tabela?.rega_dose_util_camp_4 === undefined ? null : tabela.rega_dose_util_camp_4,
            rega_dose_util_camp_5: tabela?.rega_dose_util_camp_5 === undefined ? null : tabela.rega_dose_util_camp_5,
            rega_dose_util_camp_6: tabela?.rega_dose_util_camp_6 === undefined ? null : tabela.rega_dose_util_camp_6,
            rega_dose_util_camp_7: tabela?.rega_dose_util_camp_7 === undefined ? null : tabela.rega_dose_util_camp_7,
            teor_agua_solo_1_camp_1: tabela?.teor_agua_solo_1_camp_1 === undefined ? null : tabela.teor_agua_solo_1_camp_1,
            teor_agua_solo_1_camp_2: tabela?.teor_agua_solo_1_camp_2 === undefined ? null : tabela.teor_agua_solo_1_camp_2,
            teor_agua_solo_1_camp_3: tabela?.teor_agua_solo_1_camp_3 === undefined ? null : tabela.teor_agua_solo_1_camp_3,
            teor_agua_solo_1_camp_4: tabela?.teor_agua_solo_1_camp_4 === undefined ? null : tabela.teor_agua_solo_1_camp_4,
            teor_agua_solo_1_camp_5: tabela?.teor_agua_solo_1_camp_5 === undefined ? null : tabela.teor_agua_solo_1_camp_5,
            teor_agua_solo_1_camp_6: tabela?.teor_agua_solo_1_camp_6 === undefined ? null : tabela.teor_agua_solo_1_camp_6,
            teor_agua_solo_1_camp_7: tabela?.teor_agua_solo_1_camp_7 === undefined ? null : tabela.teor_agua_solo_1_camp_7,
            perda_agua_camp_1: tabela?.perda_agua_camp_1 === undefined ? null : tabela.perda_agua_camp_1,
            perda_agua_camp_2: tabela?.perda_agua_camp_2 === undefined ? null : tabela.perda_agua_camp_2,
            perda_agua_camp_3: tabela?.perda_agua_camp_3 === undefined ? null : tabela.perda_agua_camp_3,
            perda_agua_camp_4: tabela?.perda_agua_camp_4 === undefined ? null : tabela.perda_agua_camp_4,
            perda_agua_camp_5: tabela?.perda_agua_camp_5 === undefined ? null : tabela.perda_agua_camp_5,
            perda_agua_camp_6: tabela?.perda_agua_camp_6 === undefined ? null : tabela.perda_agua_camp_6,
            perda_agua_camp_7: tabela?.perda_agua_camp_7 === undefined ? null : tabela.perda_agua_camp_7,
            ident_camp1: tabela?.ident_camp1 === undefined ? null : tabela.ident_camp1,
            ident_camp2: tabela?.ident_camp2 === undefined ? null : tabela.ident_camp2,
            ident_camp3: tabela?.ident_camp3 === undefined ? null : tabela.ident_camp3,
            ident_camp4: tabela?.ident_camp4 === undefined ? null : tabela.ident_camp4,
            id_horario_rega: obj_anexo_cabecalho_selecionado?.id_horario_rega,
            last_update: new Date().toISOString(),
            create_date: new Date().toISOString(),
            uuid: "",
          }
        });



        if (res.status === 200) {
          setMessage("Registado com sucesso!");

          const updatedRows = tabelas.map((row: any) => {
            if (row.id_registo_rega === tabela.id_registo_rega) {
              return res.data.result
            } else {
              return { ...row };
            }
          });
          set_flag_editado(false)

          setTabelas(updatedRows !== undefined ? updatedRows : []);
          setTabela(res.data.result)
          set_flag_edit_obj(false)
          setOpenSnackSuccess(true);
        } else {
          setMessage("Erro ao gravar!");
          setOpenSnackError(true);
        }
        setIsLoading(false);
      } catch (error: any) {
        func_print("handleUpdatetabela", error, true);
        if (error?.status === 409) {

          setMessage(error?.response.data.detail);
          setOpenSnackError(true);
        } else {
          setMessage("Erro ao efetuar a sua operação!");
          setOpenSnackError(true);
        }

        setIsLoading(false);
      }
    } else {
      setMessage("Selecione uma tabela para editar!");
      setOpenSnackError(true);
    }
  };

  // DELETE
  const handleClickOpenDelete = () => {
    setOpenDelete(true);
  };

  const handle_clone_file = async () => {
    try {

      setIsLoading(true);

      let res = await post(auth.token.cookie_token, "new_reg_horario_rega_seis_clone", {
        payload: {
          id_registo_rega: tabela?.id_registo_rega,
          mes: mes_default,
          semana_n: numero_semana_default?.toString(),
          date_camp_1: date_camp_1_default,
          date_camp_2: date_camp_2_default,
          date_camp_3: date_camp_3_default,
          date_camp_4: date_camp_4_default,
          date_camp_5: date_camp_5_default,
          date_camp_6: date_camp_6_default,
          date_camp_7: date_camp_7_default,
        }
      })

      if (res.status === 200) {
        setMessage("Registo clonado com sucesso!");
        setTabela(res.data.result)
        setTabelas((prev: any) => [...prev, res.data.result])
        set_open_modal_create_tabela(false)
        setOpenSnackSuccess(true);
        set_flag_clonar_obj(false)
      } else {
        setMessage("Erro ao clonar o registo!");
        setOpenSnackError(true);
      }
      setIsLoading(false);

    } catch (error) {
      func_print("handle_clone_file", error, true);
      setMessage("Erro ao clonar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }
  };


  const handle_on_click_calendario_clone = (data: any) => {
    const data_aux = new Date(data)

    const numero_semana = getWeekNumber(data);
    // const numero_semana = getWeekNumber(data, CALENDAR_TYPES.GREGORY);
    const dia_da_semana_selecionada = (data_aux.getDay() + 6) % 7
    const dia = dayjs(data_aux)

    const dia_1 = dia_da_semana_selecionada === 0 ? dia : dia.subtract(dia_da_semana_selecionada, 'day')
    const dia_2 = dia_1.add(1, 'day')
    const dia_3 = dia_1.add(2, 'day')
    const dia_4 = dia_1.add(3, 'day')
    const dia_5 = dia_1.add(4, 'day')
    const dia_6 = dia_1.add(5, 'day')
    const dia_7 = dia_1.add(6, 'day')

    set_numero_semana_default(numero_semana)
    set_mes_default(meses_ano[data_aux.getMonth()])
    set_date_camp_1_default(dia_1.format('YYYY/MM/DD'))
    set_date_camp_2_default(dia_2.format('YYYY/MM/DD'))
    set_date_camp_3_default(dia_3.format('YYYY/MM/DD'))
    set_date_camp_4_default(dia_4.format('YYYY/MM/DD'))
    set_date_camp_5_default(dia_5.format('YYYY/MM/DD'))
    set_date_camp_6_default(dia_6.format('YYYY/MM/DD'))
    set_date_camp_7_default(dia_7.format('YYYY/MM/DD'))

  }
  const handle_on_click_calendario = (data: any) => {
    const data_aux = new Date(data)

    const numero_semana = getWeekNumber(data);
    const dia_da_semana_selecionada = (data_aux.getDay() + 6) % 7
    const dia = dayjs(data_aux)

    const dia_1 = dia_da_semana_selecionada === 0 ? dia : dia.subtract(dia_da_semana_selecionada, 'day')
    const dia_2 = dia_1.add(1, 'day')
    const dia_3 = dia_1.add(2, 'day')
    const dia_4 = dia_1.add(3, 'day')
    const dia_5 = dia_1.add(4, 'day')
    const dia_6 = dia_1.add(5, 'day')
    const dia_7 = dia_1.add(6, 'day')

    set_numero_semana_default(numero_semana)
    set_mes_default(meses_ano[data_aux.getMonth()])
    set_date_camp_1_default(dia_1.format('YYYY/MM/DD'))
    set_date_camp_2_default(dia_2.format('YYYY/MM/DD'))
    set_date_camp_3_default(dia_3.format('YYYY/MM/DD'))
    set_date_camp_4_default(dia_4.format('YYYY/MM/DD'))
    set_date_camp_5_default(dia_5.format('YYYY/MM/DD'))
    set_date_camp_6_default(dia_6.format('YYYY/MM/DD'))
    set_date_camp_7_default(dia_7.format('YYYY/MM/DD'))

    func_print('tabelas', tabelas)

    if (tabelas === undefined || tabelas.length === 0) {

      set_open_modal_create_tabela(true)
      setCreate(true)
    } else {

      let aux_obj = tabelas?.find((el: IPage6) => numero_semana.toString() === el.semana_n.toString())

      if (aux_obj !== undefined) {
        setTabela(aux_obj)

      } else {
        setCreate(true)
      }


      set_open_modal_create_tabela(true)
    }
  }

  const handleDelete = async () => {
    try {
      let res = await del(auth.token.cookie_token, `/delete__reg_horario_rega_seis/${tabela?.id_registo_rega}`);

      if (res.status === 200) {
        setMessage("Registo eliminado com sucesso!");
        setOpenDelete(false);
        setTabela(undefined);
        setTabelas((oldRows) => [
          ...oldRows.filter((oldRow) => oldRow.id_registo_rega !== tabela?.id_registo_rega),
        ]);
        set_open_modal_create_tabela(false)
        setOpenSnackSuccess(true);
      } else {
        setMessage("Erro ao eliminar o registo!");
        setOpenSnackError(true);
      }

    } catch (error) {
      func_print("handleDelete", error, true);
      setMessage("Erro ao eliminar o registo!");
      setOpenSnackError(true);
      setIsLoading(false);
    }


  }
  return (
    <CustomThemeProvider>
      <div className={classes.root}>
        <CadernoLayout title="6 - Registo calendário Rega" />
        <main className={classes.contents}>
          <div className={classes.toolbars} />
          <Box width="80%" margin="auto">
            <BeneficiarioNomeIdAlinhadoDireita />
          </Box>

          <Snackbar
            open={openSnackSuccess}
            autoHideDuration={2000}
            onClose={() => setOpenSnackSuccess(false)}
          >
            <Alert
              onClose={() => setOpenSnackSuccess(false)}
              severity="success"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>
          <Snackbar
            open={openSnackError}
            autoHideDuration={2000}
            onClose={() => setOpenSnackError(false)}
          >
            <Alert
              onClose={() => setOpenSnackError(false)}
              severity="error"
              sx={{ width: "100%" }}
            >
              {message}
            </Alert>
          </Snackbar>

          <CabecalhoForm
            obj_anexo_cabecalho_selecionado={obj_anexo_cabecalho_selecionado}
            set_obj_anexo_cabecalho_selecionado={set_obj_anexo_cabecalho_selecionado}
          />

          {isLoading ? (
            <LoadingVulpes />
          ) : (
            obj_anexo_cabecalho_selecionado !== undefined ?
              <>
                <CustomThemeProvider>
                  <div style={{

                    display: "flex",
                    alignItems: "center",
                    justifyContent: 'center',


                  }}>

                    <Calendar
                      // activeStartDate={new Date()}

                      defaultActiveStartDate={new Date()}
                      onChange={(e) => {
                        handle_on_click_calendario(e)
                      }}
                      onClickMonth={(value, event) => {
                        set_data_selecionada(value)
                      }}
                      // value={lista_datas_preenchidas}
                      value={data_selecionada}
                      // calendarType={'gregory'}
                      locale={'pt'}
                      // defaultValue={new Date()}
                      // defaultValue={lista_datas_preenchidas}
                      // defaultView={"year"}
                      // defaultValue={[new Date(2025, 3, 1), new Date(2025, 3, 13)]}
                      // allowPartialRange={true}
                      // showFixedNumberOfWeeks={true}
                      showWeekNumbers={true}
                      maxDate={new Date(('01/01/' + (new Date().getFullYear() + 1)))}
                      minDate={new Date(('01/01/' + (new Date().getFullYear())))}
                    // navigationAriaLabel={"Go up"}
                    // goToRangeStartOnSelect={true}
                    // formatShortWeekday={(locale, date) => formatDate(locale, date)}
                    />
                  </div>
                  <Modal
                    style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'center',
                    }}
                    open={open_modal_create_tabela}
                  >
                    <div style={{
                      display: 'flex',
                      alignItems: 'center',
                      justifyContent: 'flex-start',
                      backgroundColor: 'white',
                      width: '95%',
                      height: '95%',
                      flexDirection: 'column',
                      borderRadius: 5,
                    }}>
                      <div style={{
                        width: '100%',
                        display: "flex",
                        alignItems: 'center',
                        justifyContent: 'flex-end',
                      }}>
                        <Button
                          sx={{ color: "#AAAAAA" }}
                          size="large"
                          onClick={() => {
                            if (flag_editado) {
                              set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)

                            } else {

                              set_open_modal_create_tabela(false)
                              setTabela(undefined)
                              set_flag_edit_obj(false)
                              setCreate(false)
                              set_flag_clonar_obj(false)
                            }

                          }}
                        >
                          <CloseIcon />
                        </Button>
                      </div>

                      {create === true ?
                        <TableContainer
                          component={Paper}
                          sx={{
                            height: "auto",
                            width: "auto",
                            marginLeft: 2,
                            marginRight: 2,
                            padding: 2,
                          }}
                        >
                          <table style={{ width: "100%" }}>
                            <TableBody>
                              <TableRow>
                                <TableCell colSpan={8}>
                                  <Box sx={{ justifyContent: "end", display: "flex", }}>
                                    {is_historico === true ? <></> :

                                      <ButtonCadernos
                                        mostrarBotaoGravar
                                        aoClicarGravar={() => handleSaveTabela()}
                                      />}
                                  </Box>
                                </TableCell>
                              </TableRow>
                              <TableRow>
                                <TabelaCalendarioRega
                                  tabela={tabela}
                                  setTabela={setTabela}
                                  numero_semana_default={numero_semana_default}
                                  mes_default={mes_default}
                                  date_camp_1_default={date_camp_1_default}
                                  date_camp_2_default={date_camp_2_default}
                                  date_camp_3_default={date_camp_3_default}
                                  date_camp_4_default={date_camp_4_default}
                                  date_camp_5_default={date_camp_5_default}
                                  date_camp_6_default={date_camp_6_default}
                                  date_camp_7_default={date_camp_7_default}
                                  set_date_camp_1_default={set_date_camp_1_default}
                                  set_date_camp_2_default={set_date_camp_2_default}
                                  set_date_camp_3_default={set_date_camp_3_default}
                                  set_date_camp_4_default={set_date_camp_4_default}
                                  set_date_camp_5_default={set_date_camp_5_default}
                                  set_date_camp_6_default={set_date_camp_6_default}
                                  set_date_camp_7_default={set_date_camp_7_default}
                                  set_flag_editado={set_flag_editado}
                                ></TabelaCalendarioRega>
                              </TableRow>
                            </TableBody>
                          </table>
                        </TableContainer>
                        :
                        flag_edit_obj === true ?
                          <TableContainer
                            component={Paper}
                            sx={{
                              height: "auto",
                              width: "auto",
                              marginLeft: 2,
                              marginRight: 2,
                              padding: 2,
                            }}
                          >
                            <table style={{ width: "100%" }}>
                              <TableBody>
                                <TableRow>
                                  <TableCell colSpan={8}>
                                    <Box sx={{ justifyContent: "end", display: "flex", }}>
                                      <ButtonCadernos
                                        mostrarBotaoGravar
                                        aoClicarGravar={() => { handleUpdatetabela() }}

                                        mostrarBotaoCancelar
                                        aoClicarCancelar={() => {
                                          if (flag_editado) {
                                            set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(true)
                                          } else {
                                            set_flag_edit_obj(false)
                                            setCreate(false)
                                          }
                                        }}
                                      />
                                    </Box>
                                  </TableCell>
                                </TableRow>
                                <TableRow>
                                  <TabelaCalendarioRega
                                    tabela={tabela}
                                    setTabela={setTabela}
                                    numero_semana_default={numero_semana_default}
                                    mes_default={mes_default}
                                    date_camp_1_default={date_camp_1_default}
                                    date_camp_2_default={date_camp_2_default}
                                    date_camp_3_default={date_camp_3_default}
                                    date_camp_4_default={date_camp_4_default}
                                    date_camp_5_default={date_camp_5_default}
                                    date_camp_6_default={date_camp_6_default}
                                    date_camp_7_default={date_camp_7_default}

                                    set_date_camp_1_default={set_date_camp_1_default}
                                    set_date_camp_2_default={set_date_camp_2_default}
                                    set_date_camp_3_default={set_date_camp_3_default}
                                    set_date_camp_4_default={set_date_camp_4_default}
                                    set_date_camp_5_default={set_date_camp_5_default}
                                    set_date_camp_6_default={set_date_camp_6_default}
                                    set_date_camp_7_default={set_date_camp_7_default}
                                    set_flag_editado={set_flag_editado}
                                  ></TabelaCalendarioRega>
                                </TableRow>

                              </TableBody>
                            </table>
                          </TableContainer> :
                          flag_clonar_obj === false ?
                            <TableContainer
                              component={Paper}
                              sx={{
                                height: "auto",
                                width: "auto",
                                marginLeft: 2,
                                marginRight: 2,
                                padding: 2,
                              }}
                            >
                              <table style={{ width: "100%" }}>
                                <TableBody>
                                  <TableRow>
                                    <StyledTableCellCabecalho colSpan={8}>
                                      {is_historico === true ? <></> :

                                        <Stack direction="row" sx={{ justifyContent: "end" }}>
                                          <Button
                                            sx={{ color: cores.cor1 }}
                                            size="large"
                                            onClick={() => {
                                              set_flag_clonar_obj(true)
                                            }}
                                          >
                                            <FileCopyIcon />
                                          </Button>
                                          <ButtonCadernos
                                            mostrarBotaoEditar
                                            aoClicarEditar={() => {
                                              set_flag_edit_obj(true)
                                            }}
                                            mostrarBotaoApagar
                                            aoClicarApagar={() => handleClickOpenDelete()}
                                          />


                                        </Stack>}

                                    </StyledTableCellCabecalho>
                                  </TableRow>


                                  <TableRow>
                                    <StyledTableHeadLeft> Capacidade utilizável (m3/m3): </StyledTableHeadLeft>
                                    <StyledTableCell> {tabela?.capacidade_utili}</StyledTableCell>
                                    <TableCell></TableCell>
                                    <StyledTableHeadLeft>Eficiência da rega:</StyledTableHeadLeft>
                                    <TableCell> </TableCell>
                                    <StyledTableHeadLeft> mês:</StyledTableHeadLeft>
                                    <TableCell> </TableCell>
                                    <StyledTableHeadLeft>
                                      Semana n.º:
                                      <BasicPopover
                                        text={"Preencher com o n.º da semana ao qual diz respeito o calendário de rega e ano cívil"} />
                                    </StyledTableHeadLeft>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>Reserva facilmente utilizável (m3/m3):</StyledTableHeadLeft>
                                    <StyledTableCell> {tabela?.reserva_facilmente_utiliz} </StyledTableCell>
                                    <TableCell></TableCell>
                                    <StyledTableCell> {tabela?.eficiencia_rega}</StyledTableCell>
                                    <TableCell></TableCell>
                                    <StyledTableCell>{tabela?.mes}</StyledTableCell>
                                    <TableCell></TableCell>
                                    <StyledTableCell> {tabela?.semana_n ? tabela?.semana_n : ""}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell></TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>
                                      <Stack direction="row" justifyContent="end" alignItems="center">
                                        Data
                                        <BasicPopover
                                          text={"Identificar, em cada um dos campos seguintes o dia da semana, dia do mês e mês"} />
                                      </Stack>
                                    </StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_1 || '') || ""}</StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_2 || '') || ""}</StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_3 || '') || ""}</StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_4 || '') || ""}</StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_5 || '') || ""}</StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_6 || '') || ""}</StyledTableHeadLeft>
                                    <StyledTableHeadLeft>{format_date_type_DD_MMM_ddd(tabela?.date_camp_7 || '') || ""}</StyledTableHeadLeft>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>
                                      <Stack direction="row" justifyContent="end">
                                        DIA DO CICLO VEGETATIVO
                                      </Stack>
                                    </StyledTableHeadLeft>
                                    <StyledTableCell></StyledTableCell>
                                    <StyledTableCell> </StyledTableCell>
                                    <StyledTableCell> </StyledTableCell>
                                    <StyledTableCell> </StyledTableCell>
                                    <StyledTableCell> </StyledTableCell>
                                    <StyledTableCell> </StyledTableCell>
                                    <StyledTableCell> </StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>PROFUNDIDADE RADICULAR (m)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.prefundidad_radi_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.prefundidad_radi_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft> CAPACIDADE DE CAMPO (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.capacidade_campo_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.capacidade_campo_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>TEOR CRÍTICO CULTURAL (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_crit_cul_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_crit_cul_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>TEOR DE ÁGUA DO SOLO - INÍCIO (mm) </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_inicio_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_inicio_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>ET0 (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.eto_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.eto_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.eto_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.eto_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.eto_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.eto_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.eto_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.eto_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>KC</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.kc_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.kc_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.kc_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.kc_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.kc_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.kc_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.kc_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.kc_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>ETC (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.etc_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.etc_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.etc_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.etc_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.etc_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.etc_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.etc_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.etc_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>PRECIPITAÇÃO TOTAL (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.precipita_t_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.precipita_t_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.precipita_t_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.precipita_t_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.precipita_t_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.precipita_t_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.precipita_t_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.precipita_t_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft> VARIAÇÃO DA ÁGUA NO SOLO (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.variacao_agu_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.variacao_agu_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft> TEOR DE ÁGUA DO SOLO - SEM REGA (mm) </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_s_rega_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_s_rega_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>
                                      <Stack direction="row" alignItems="center">
                                        LEITURA DA SONDA (% OU kPa)
                                        <BasicPopover text={"A ser preenchido apenas por regantes da classe A e B+."} />
                                      </Stack>
                                    </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_1_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_1_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>
                                      <Stack direction="row" alignItems="center" >
                                        LEITURA DA SONDA (mm)
                                        <BasicPopover text={"A ser preenchido apenas por regantes da classe A e B+."} />
                                      </Stack>
                                    </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.leitura_sonda_2_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.leitura_sonda_2_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft> FOLGA PARA PRÓXIMA REGA (mm) </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.folga_prox_rega_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.folga_prox_rega_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>REGA - LEITURA DO CONTADOR NO FINAL (m3) </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_leitura_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_leitura_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft> REGA - DOSE TOTAL APLICADA (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_total_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_total_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>REGA - DOSE ÚTIL (mm) – APÓS REGA </StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.rega_dose_util_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.rega_dose_util_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft>TEOR DE ÁGUA DO SOLO (mm)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.teor_agua_solo_1_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.teor_agua_solo_1_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableHeadLeft> PERDA DE ÁGUA (CHUVA OU REGA EXCESSIVA)</StyledTableHeadLeft>
                                    <StyledTableCell>{tabela?.perda_agua_camp_1 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_1)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.perda_agua_camp_2 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_2)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.perda_agua_camp_3 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_3)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.perda_agua_camp_4 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_4)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.perda_agua_camp_5 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_5)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.perda_agua_camp_6 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_6)}</StyledTableCell>
                                    <StyledTableCell>{tabela?.perda_agua_camp_7 === undefined ? '0,00' : formatarNumero_recebido_com_casa_decimais(tabela?.perda_agua_camp_7)}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell sx={{ fontWeight: 600, paddingTop: 10, fontFamily: "candara", fontSize: 14, }} >
                                      PREENCHER APENAS OS CAMPOS QUE SE APLICAM
                                    </TableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell sx={{ fontFamily: "candara", fontSize: 14 }}>
                                      <Stack direction="row" justifyContent="left" alignItems="center">
                                        IDENTIFICAÇÃO DO AVISO DE REGA com sonda (Data):
                                        <BasicPopover
                                          text={"A ser preenchido apenas por regantes da classe A."} />
                                      </Stack>
                                    </TableCell>
                                    <StyledTableCell>{tabela?.ident_camp1}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell sx={{ fontFamily: "candara", fontSize: 14 }}>
                                      <Stack direction="row" justifyContent="left" alignItems="center">
                                        IDENTIFICAÇÃO DO AVISO DE REGA com sonda
                                        (dotação recomendada m3/ha):
                                        <BasicPopover
                                          text={"A ser preenchido apenas por regantes da classe A."} />
                                      </Stack>
                                    </TableCell>
                                    <StyledTableCell>{tabela?.ident_camp2}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <TableCell sx={{ fontFamily: "candara", fontSize: 14 }}>
                                      <Stack direction="row" justifyContent="left" alignItems="center">
                                        IDENTIFICAÇÃO DO AVISO DE REGA com imagem
                                        satélite IVDI (Data):
                                        <BasicPopover text={"A ser preenchido apenas por regantes da classe A."} />
                                      </Stack>
                                    </TableCell>
                                    <StyledTableCell>{tabela?.ident_camp3}</StyledTableCell>
                                  </TableRow>
                                  <TableRow>
                                    <StyledTableCellCabecalho>
                                      <Stack direction="row" justifyContent="left" alignItems="center">
                                        IDENTIFICAÇÃO DO AVISO DE REGA com imagem
                                        satélite IVDI (dotação recomendada m3/ha):
                                        <BasicPopover text={"A ser preenchido apenas por regantes da classe A."} />
                                      </Stack>
                                    </StyledTableCellCabecalho>
                                    <StyledTableCell>{tabela?.ident_camp4}</StyledTableCell>
                                  </TableRow>

                                </TableBody>
                              </table>
                            </TableContainer>
                            :
                            <div style={{
                              flex: 1,
                              display: "flex",
                              alignItems: 'center',
                              justifyContent: 'flex-start',
                              flexDirection: 'column',
                              alignSelf: 'center',
                              justifySelf: 'center',


                            }}>

                              <div style={{
                                fontSize: 20,
                                fontWeight: 'bold',
                                display: 'flex',
                                paddingTop: '5%',
                                flex: 0.2,

                              }}>
                                Clonar registo existente anteriormente
                              </div>
                              <div style={{
                                display: 'flex',
                                flex: 0.1,

                              }}>
                                Selecione data pretendida
                              </div>
                              <div style={{
                                display: 'flex',
                                flex: 0.4,

                              }}>
                                <Calendar
                                  // defaultActiveStartDate={new Date()}
                                  onChange={(e) => {
                                    handle_on_click_calendario_clone(e)
                                  }}
                                  onClickMonth={(value, event) => {
                                    set_data_selecionada(value)
                                  }}
                                  // value={data_selecionada}
                                  locale={'pt'}
                                  // defaultValue={new Date()}
                                  showWeekNumbers={true}
                                  maxDate={new Date(('01/01/' + (new Date().getFullYear() + 1)))}
                                  minDate={new Date(('01/01/' + (new Date().getFullYear())))}
                                />
                              </div>

                              <div style={{
                                display: 'flex',
                                flex: 0.3,
                                paddingTop: '17%',
                                alignItems: 'flex-start',
                                justifyContent: 'center',
                                width: '100%',
                              }}>
                                {is_historico === true ? <></> :

                                  <Button style={{
                                    backgroundColor: cores.cor1,
                                    color: 'white',
                                    width: '50%',
                                    height: '20%',

                                  }}

                                    onClick={() => {
                                      handle_clone_file()
                                    }}
                                  >
                                    Criar clone
                                  </Button>}
                              </div>

                            </div>
                      }


                    </div>
                  </Modal>
                </CustomThemeProvider>
              </>
              : <></>
          )}
          <ConfirmDialog
            open={openDelete}
            onClose={() => setOpenDelete(false)}
            onConfirm={handleDelete}
            message="Deseja eliminar o registo?"
          />
          <ConfirmDialog
            open={open_modal_tem_a_certeza_que_quer_apagar_alteracoes}
            onClose={() => set_open_modal_tem_a_certeza_que_quer_apagar_alteracoes(false)}
            onConfirm={() => handleCloseDialog()}
            message={mensagem_tem_a_certeza_de_apagar_alteracoes}
          />
        </main>
      </div>
    </CustomThemeProvider >
  );
}
